module.exports = __webpack_public_path__ + "img/21.ac30b2de.png";